<style scoped>
    @import url("../../../styles/smartControl/cyclePhase.scss");
</style>

<template>
    <div class="box_cyclePhase">

        <v-expansion-panels accordion class="cardExpansor">

            <v-expansion-panel class="el_cardExpansor">

                <v-expansion-panel-title class="titCardExpansor">

                    <!-- ciclo desabilitada -->
                    <v-icon v-if="cycleLocal.status == 'off'" 
                    size="32" 
                    color="gray"
                    >
                        mdi-circle
                    </v-icon>

                    <!-- ciclo ativa e aguardando -->
                    <v-icon v-else-if="cycleLocal.status == 'on' && cycleLocal.active == false" 
                    size="32" 
                    color="yellow"
                    >
                        mdi-circle
                    </v-icon>

                    <!-- ciclo ativa e em operação -->
                    <v-icon v-else-if="cycleLocal.status == 'on' && cycleLocal.active == true" 
                    size="32" 
                    color="green"
                    >
                        mdi-circle
                    </v-icon>

                    <!-- estado não previsto -->
                    <v-icon v-else
                    size="32" 
                    color="red"
                    >
                        mdi-circle
                    </v-icon>

                    <v-chip color="" class="ml-2">{{ cycleLocal.cycle_name }}</v-chip>
                    
                    <v-chip color="#092D4F" class="ml-2" :style="{'font-size':'0.7rem'}">
                        <div class="ml-1">{{ 'ID '+cycleLocal.cycle_id }}</div>
                    </v-chip>

                    <v-chip color="#092D4F" class="ml-2" :style="{'font-size':'0.7rem'}">
                        <div class="ml-1">{{ 'Minutos de duração: '+cycleLocal.duration_sec / 60 }}</div>
                    </v-chip>

                </v-expansion-panel-title>

                <v-expansion-panel-text class="respCardExpansor">

                    <div class="transCard mb-4">
                        <div class="subTit">Tempo total do ciclo</div>
                        <div class="subPainel">
                            <v-text-field
                            v-model="cycleLocal.duration_sec_string"
                            class="w-100"
                            color="rgb(247,215,46)"
                            variant="plain"
                            bg-color="transparent"
                            ></v-text-field>
                        </div>
                    </div>

                    <!-- TRANSICAO -->
                    <div class="titRespCard">
                        <v-icon>mdi-transition</v-icon>
                        <div class="ml-1" :style="{'color':'#F39C12'}">Transição</div>
                    </div>

                    <div class="transCard">
                        <div class="subTit">Tempo de transição</div>
                        <div class="subPainel">
                            <v-text-field
                            v-model="cycleLocal.duration_transition_sec_string"
                            class="w-100"
                            color="rgb(247,215,46)"
                            variant="plain"
                            bg-color="transparent"
                            ></v-text-field>
                        </div>
                    </div>

                    <!-- elementos de transição de entrada o ciclo -->
                    <div class="painelTransCard mt-1" v-if="cycleLocal.li_transition_entry.length > 0">
                        <div class="elTransCard mt-1" 
                        v-for="(elTrans,k) in cycleLocal.li_transition_entry" :key="k"
                        @click="openElAct(elTrans,k,'li_transition_entry')"
                        >
                            <div class="subElTransCard">
                                <span>{{ `Transição ${k+1}` }}</span>
                                <v-chip color="#092D4F" class="ml-1"
                                :style="{'font-size':'0.7rem','height':'20px'}"
                                >
                                    <div class="">{{ 'Atuador '+elTrans.actuator_name }}</div>
                                </v-chip>
                                <v-icon class="ml-1">mdi-open-in-new</v-icon>
                            </div>
                            <div class="subElTransCard">
                                <span v-if="elTrans.status == 'on'">Habilitada</span>
                                <span v-else-if="elTrans.status == 'off'">Desabilitada</span>
                                <span v-else>Indefinido</span>
                            </div>
                        </div>
                    </div>
                    <div class="painelTransCard mt-1" v-else>
                        <v-chip :style="{'font-size':'0.7rem'}">Nenhum elemento de transição registrado para esse ciclo.</v-chip>
                    </div>

                    <!-- DISPAROS AO ENTRAR NO CICLO -->
                    <div class="titRespCard mt-2">
                        <v-icon>mdi-clock-start</v-icon>
                        <div class="ml-1" :style="{'color':'#F39C12'}">Entrada</div>
                    </div>

                    <div class="painelTransCard mt-1" v-if="cycleLocal.li_action_on_cycle_start.length > 0">
                        <div class="elTransCard mt-1" 
                        v-for="(elIN,k2) in cycleLocal.li_action_on_cycle_start" :key="k2"
                        @click="openElAct(elIN,k2,'li_action_on_cycle_start')"
                        >
                            <div class="subElTransCard">
                                <span>{{ `Entrada ${k2+1}` }}</span>
                                <v-chip color="#092D4F" class="ml-1"
                                :style="{'font-size':'0.7rem','height':'20px'}"
                                >
                                    <div class="">{{ 'Atuador '+elIN.actuator_name }}</div>
                                </v-chip>
                                <v-icon class="ml-1">mdi-open-in-new</v-icon>
                            </div>
                            <div class="subElTransCard">
                                <span v-if="elIN.status == 'on'">Habilitada</span>
                                <span v-else-if="elIN.status == 'off'">Desabilitada</span>
                                <span v-else>Indefinido</span>
                            </div>
                        </div>
                    </div>
                    <div class="painelTransCard mt-1" v-else>
                        <v-chip :style="{'font-size':'0.7rem'}">Nenhum elemento de entrada registrado para esse ciclo.</v-chip>
                    </div>

                    <!-- CICLO PLENO -->
                    <div class="titRespCard mt-2">
                        <v-icon>mdi-wrench-clock-outline</v-icon>
                        <div class="ml-1" :style="{'color':'#F39C12'}">Operação plena</div>
                    </div>

                    <div class="painelTransCard mt-1" v-if="cycleLocal.li_crossings.length > 0">
                        <div class="elTransCard mt-1" 
                        v-for="(elOp,k3) in cycleLocal.li_crossings" :key="k3"
                        @click="openElAct(elOp,k3,'li_crossings')"
                        >
                            <div class="subElTransCard">
                                <span>{{ `Limiar ${k3+1}` }}</span>
                                <v-chip color="#092D4F" class="ml-1"
                                :style="{'font-size':'0.7rem','height':'20px'}"
                                >
                                    <div class="">{{ 'Atuador '+elOp.actuator_name }}</div>
                                </v-chip>
                                <v-icon class="ml-1">mdi-open-in-new</v-icon>
                            </div>
                            <div class="subElTransCard">
                                <span v-if="elOp.status == 'on'">Habilitada</span>
                                <span v-else-if="elOp.status == 'off'">Desabilitada</span>
                                <span v-else>Indefinido</span>
                            </div>
                        </div>
                    </div>
                    <div class="painelTransCard mt-1" v-else>
                        <v-chip :style="{'font-size':'0.7rem'}">Nenhum elemento de rompimento registrado para esse ciclo.</v-chip>
                    </div>

                </v-expansion-panel-text>

            </v-expansion-panel>

        </v-expansion-panels>

    </div>
</template>

<script>
// @keyup.enter.prevent="chamada()"
// :rules="nameRules"

export default {

    props:['cycle','cycleIndex'],

    data() {
        return {
            //
            cycleLocal:{},
            cycle_snapshot:{},
            segundosDeCiclo:0,
            flagSnapActive:false,
            flagChanged:false,
        }
    },

    watch: {
        cycleLocal: {
            deep: true,
            handler() {
                this.watchChange(); // call func in local methods
            }
        }
    },

    methods:{
        openElAct(el,index,srcStr) {
            //console.log('el: ',el)
            //console.log('index: ',index)
            //console.log('srcStr: ',srcStr)
            const doc2edit = {
                'srcStr':srcStr,
                'indexCycle':this.cycleIndex,
                'index':index,
                'doc':el
            }
            this.$emit('doc2edit',doc2edit)
            this.$emit('flagBoolOpenFormAgend',true)
        },

        HHMMSStoSegundos(hhmmss) {
            // Quebra a string "HH:MM:SS" em partes
            const [h, m, s] = hhmmss.split(":").map(Number);
            // Converte para inteiro em segundos
            return (h * 3600) + (m * 60) + s;
        },

        segundosParaHHMMSS(totalSegundos) {

            let horas = Math.floor(totalSegundos / 3600);
            let minutos = Math.floor((totalSegundos % 3600) / 60);
            let segundos = totalSegundos % 60;
            //console.log('[segundosParaHHMMSS] segundos: ',segundos)

            const pad = (num) => String(num).padStart(2, '0');

            return `${pad(horas)}:${pad(minutos)}:${pad(segundos)}`;
        },

        async prepareExib() {
            
            this.cycleLocal = structuredClone(this.cycle) // rcv via props | depth copy

            // -- tempo total ciclo.
            this.cycleLocal.duration_sec_string = this.segundosParaHHMMSS(this.cycleLocal.duration_sec);

            // -- tempo da transição de entrada no ciclo.
            this.cycleLocal.duration_transition_sec_string = this.segundosParaHHMMSS(this.cycleLocal.duration_transition_sec);

            this.cycle_snapshot = structuredClone(this.cycleLocal); // depth copy
            this.cycleLocal = structuredClone(this.cycle_snapshot); // depth copy

            this.flagSnapActive = true
            return 'ok-prepareExib'
        },

        watchChange() { 
            if (!this.flagSnapActive) { return; }

            this.flagChanged = JSON.stringify(this.cycleLocal) !== JSON.stringify(this.cycle_snapshot); 

            if (!this.flagChanged) { return; }

            console.log('[CycleFase] changed!')

            let cycleFinal = structuredClone(this.cycleLocal)

            cycleFinal.duration_sec = this.HHMMSStoSegundos(cycleFinal.duration_sec_string);
            cycleFinal.duration_transition_sec = this.HHMMSStoSegundos(cycleFinal.duration_transition_sec_string);

            // --> emitir doc editado ao pai
            const dictInfo = {
                'indexCycle':this.cycleIndex, // rcv via props
                'cycleFinal':cycleFinal,
            }
            this.$emit('infoCycleEdited', dictInfo)
        },
    },

    async created() {
        const res = await this.prepareExib()
        console.log('[CycleFase] init: ',res)
    }
}
</script>